/**
 */

define('directives/myreport/app-task-checkbox.directives',['app'], function (app) {
    app.directive('multipleCheckbox', function () {
        return {
            restrict: 'E',
            templateUrl: '../refactor/directives/myreport/app.task.checkbox.template.html',
            replace: true,
            scope: {
                appTaskFun: '='
            },
            require: "?ngModel",
            link: function ($scope, element, attrs, ngModelCtrl) {
                $scope.noData = true;
                $scope.showAppTask = false;
                $scope.checked = {};
                $scope.checkHalf = checkHalf;
                $scope.changeCountry = function (id, $event) {
                    $scope.currentID = id;
                    var node = getNode(id);
                    $scope.subCountry = node.currentNode.children;
                    if ("ucd-check-mark" != $event.originalEvent.target.className && $event.originalEvent.target.className.indexOf("ucd-check-input") == -1) {
                        $event.preventDefault();
                    }
                    return false;
                };
                $scope.triggerAppTask = function () {
                    if (angular.element('#checkBox4appTask.ng-hide').length > 0) {
                        angular.element('#checkBox4appTask').removeClass('ng-hide');
                        angular.element('#appTask').text('收起任务');
                    }else{
                        angular.element('#checkBox4appTask').addClass('ng-hide');
                        angular.element('#appTask').text('选择任务');
                    }
                };
                $scope.prevent = function ($event) {
                    $event.stopPropagation();
                };
                $scope.selectSingle = function (id) {
                    $scope.checked[id] = !!!$scope.checked[id];
                    // 就判断当前节点的同级节点是否全部选中，如果是，选中其父级checkbox
                    selectParent(id);
                    // 就判断当前节点是否有子节点，如果是，全部选中
                    selectChild(id);

                    var result = [];
                    for (var i in $scope.checked) {
                        if ($scope.checked[i]) {
                            result[result.length] = i;
                        }
                    }

                    ngModelCtrl.$setViewValue(result);
                };

                function checkHalf(id) {
                    var node = getNode(id);
                    var tempLength = 0;
                    var tempHalfLength = 0;
                    var tempAllLength = 0;
                    angular.forEach(node.currentNode.children, function (i) {
                        if (i.disabled) {
                            return;
                        }
                        if (id != 'all') {
                            if ($scope.checked[i.id]) {
                                tempLength++;
                            }
                        } else {
                            if (checkHalf(i.id)) {
                                tempHalfLength++;
                            }
                            if ($scope.checked[i.id]) {
                                tempAllLength++;
                            }
                        }
                    });
                    if ((tempHalfLength + tempAllLength) != 0 && (tempHalfLength > 0 || (tempHalfLength + tempAllLength) != node.currentNode.children.length)) {
                        return true;
                    }
                    if (tempLength != 0 && tempLength != node.currentNode.children.length) {
                        return true;
                    }

                }


                if (typeof $scope.appTaskFun == 'function') {
                    $scope.appTaskFun().then(function (data) {
                        $scope.appTaskList = data.appTaskList;

                        if (!$scope.appTaskList || $scope.appTaskList.length == 0) {
                            $scope.noData = true;
                            return false;
                        }
                        $scope.noData = false;
                        // 第一次进入页面的时候，显示第一个国家的子国家
                        $scope.currentID = $scope.appTaskList[0].id;
                        $scope.subCountry = $scope.appTaskList[0].children;

                        ngModelCtrl.$formatters.push(function (modelValue) {
                            $scope.checked = {};
                            if (typeof modelValue != "undefined") {
                                for (var i in modelValue) {
                                    $scope.checked[modelValue[i]] = true;
                                }
                            }
                        });
                    });
                }

                function selectChild(id) {
                    var node = getNode(id);
                    var isCheckAll = true;
                    angular.forEach(node.currentNode.children, function (i) {
                        if (i.disabled) {
                            return;
                        }
                        $scope.checked[i.id] = $scope.checked[id];
                        if (i.children) {
                            // 递归执行子级选择
                            selectChild(i.id);
                        }
                    });
                }

                function selectParent(id) {
                    var node = getNode(id);
                    if (!node.parent) {
                        return;
                    }
                    var isCheckAll = true;
                    angular.forEach(node.parent.children, function (i) {
                        if (i.disabled) {
                            return;
                        }
                        if (!$scope.checked[i.id]) {
                            isCheckAll = false;
                        }
                    });
                    if (isCheckAll) {
                        $scope.checked[node.parent.id] = true;
                    }
                    else {
                        $scope.checked[node.parent.id] = false;
                    }
                    if ("all" != node.parent.id) {
                        // 递归执行父级选择
                        selectParent(node.parent.id);
                    }
                }

                function getNode(id, parent) {
                    parent = parent || {id: "all", children: $scope.appTaskList};
                    if (parent.id == id) {
                        return {
                            currentNode: parent,
                            parent: null
                        }
                    }
                    else {
                        for (var i in parent.children) {
                            var node = parent.children[i];
                            if (node.id == id) {
                                return {
                                    currentNode: node,
                                    parent: parent
                                }
                            }
                            else {
                                if (node.children) {
                                    var result = getNode(id, node);
                                    if (result) {
                                        return result;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        };
    });
});

